import { Box, Modal as MuiModal, useTheme } from "@mui/material";
import onboardingModalBg from "assets/images/onboarding/onboarding-modal-bg.webp";
import {
  useGetOnboarding,
  useNonPersistantMainStore,
  useSetMspFeatureFlagAsSeen,
} from "controller";
import { useEffect, useRef, useState } from "react";
import { OnboardingModalBody } from "./OnboardingModalBody";

const getIsModalOpen = (onboardingData: unknown): boolean => {
  if (onboardingData === undefined) return false;
  if (onboardingData === null) return true;
  const data = onboardingData as {
    setupSequence?: { stage_key?: string; is_completed?: boolean }[];
  };
  const sourceFormStage = data.setupSequence?.find(
    (item) => item.stage_key === "source-form",
  );
  return !sourceFormStage?.is_completed;
};

export const OnboardingModal = (): JSX.Element => {
  const theme = useTheme();
  const { data: onboardingData } = useGetOnboarding();

  const [isOpen, setIsOpen] = useState(getIsModalOpen(onboardingData));
  const { mutateAsync: setMspFeatureAsSeen } = useSetMspFeatureFlagAsSeen();
  const hasTriedFix = useRef(false);

  useEffect(() => {
    setIsOpen(getIsModalOpen(onboardingData));
  }, [onboardingData]);

  // Self-heal: if source-form is already completed but show_onboarding_screen
  // is still true (stale flag), fix it so MainWrapper renders the app.
  useEffect(() => {
    if (
      onboardingData !== undefined &&
      !getIsModalOpen(onboardingData) &&
      !hasTriedFix.current
    ) {
      hasTriedFix.current = true;
      // Update store immediately so MainWrapper switches to {children}
      useNonPersistantMainStore.setState((state) => ({
        featureFlags: { ...state.featureFlags, show_onboarding_screen: false },
      }));
      // Fire-and-forget API call to persist the change
      setMspFeatureAsSeen("show_onboarding_screen");
    }
  }, [onboardingData, setMspFeatureAsSeen]);

  const handleClose = (): void => {
    setIsOpen(false);
  };

  return (
    <MuiModal
      open={isOpen}
      // open={true}
      onClose={() => {
        /* intentionally non-closable */
      }}
      aria-labelledby="onboarding-modal"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      slotProps={{
        backdrop: {
          sx: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            width: "100vw",
            height: "100vh",
            backgroundImage: `url(${onboardingModalBg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          },
        },
      }}
    >
      <Box
        sx={{
          width: "478px",
          height: "555px",
          backgroundColor: theme.palette.primitive.neutrals.neutral[900],
          borderRadius: "24px",
          padding: "32px 32px 0 32px",
          outline: "none",
          boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.4)",
        }}
      >
        <OnboardingModalBody onClose={handleClose} />
      </Box>
    </MuiModal>
  );
};
